import { render, staticRenderFns } from "./types-comp.vue?vue&type=template&id=fd5f82c4&scoped=true&"
import script from "./types-comp.vue?vue&type=script&lang=js&"
export * from "./types-comp.vue?vue&type=script&lang=js&"
import style0 from "./types-comp.vue?vue&type=style&index=0&id=fd5f82c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5f82c4",
  null
  
)

export default component.exports